import { Actioner } from "@services/actioner";
import { Result } from "@services/sdk/models";
import type ErrorResponse from "@services/sdk/models/error-response";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import type { AxiosInstance } from "axios";

export const createMRTMPortingAdapter = (httpClient: AxiosInstance) => ({
	async verifyPhoneNumber(
		number: string,
	): Promise<Result<boolean, ErrorResponse>> {
		try {
			await httpClient.get("/portin/check", {
				params: {
					portNumber: number,
				},
			});
			return Result.Success(true);
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorVerifyPhoneNumber(err));
		}
	},
});
